import { get } from 'lib/API';
import { RecommendationSectionItem, RecommendationTitle } from 'data/Product';

export const loadRecommendationTitles = async ({ token }: any): Promise<RecommendationTitle[]> => {
  return await get('v2/products/recommendations/titles', token);
};

export const searchRecommendationProducts = async (
  [search, vendorId, excludeCode]: any[],
  { token }: any
): Promise<RecommendationSectionItem[]> => {
  return await get('v2/products/recommendations/search', token, {
    search,
    ...(vendorId ? { vendorId } : {}),
    ...(excludeCode ? { excludeCode } : {})
  });
};
